import React from 'react'
import './other-card.less'
import classNames from 'classnames';

const OtherCard = (props) => {
  return (
    <div className={classNames('other-card', {'other-card--v2': props.v2}, {'other-card--v3': props.v3})}>
      <div className='other-card__content'>
        {props.content}
      </div>
      <div className='other-card__action'>
        {props.actions}
      </div>
    </div>
  )
}

export default OtherCard